import React from 'react';
import Tooltip from '../../Component/Tooltip';

const TextArea = ({
  current_data,
  update_data,
  title,
  note,
  id,
  placeholder,
  type,
  isRequired,
  disabled = false,
  title_style,
  field_style,
  tooltip,
}) => {
  return (
    <div className="space-y-1">
      {title && (
        <div className="flex items-center gap-1">
          <p
            className={[
              'text-gray-600',
              isRequired &&
                "flex-none relative after:content-['*'] after:text-red-500 after:-top-[5px] after:-right-[12px] ",
            ].join(' ')}
            style={title_style}>
            {title}
          </p>
          {tooltip && <Tooltip title={title} description={tooltip} />}
        </div>
      )}
      <textarea
        id={id}
        key={id}
        rows={6}
        value={current_data}
        className="form-input py-2 w-full"
        onChange={e => {
          update_data(e.target.value);
        }}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={disabled}
        style={field_style}
      />
      {note && <p className="text-xs mt-2 italic">{note}</p>}
    </div>
  );
};

export default TextArea;
